import client from "libs/HttpClient";

/**
 * Service class for handling Traffic monitoring.
 */
class TrafficService {
  /**
   * get server-wide traffic summary (today/week/month + live).
   *
   * @returns A Promise that resolves to the Axios response.
   */
  static getSummary() {
    return client.get("admin/traffic/summary");
  }

  /**
   * get per-user traffic for a period.
   *
   * @param request - { period, page, limit, search } query params.
   * @returns A Promise that resolves to the Axios response.
   */
  static getUserTraffic(request: any) {
    return client.get("admin/traffic/users", { params: request });
  }

  /**
   * get live view (connected VPN clients + last-minute HTTP hosts).
   *
   * @returns A Promise that resolves to the Axios response.
   */
  static getLive() {
    return client.get("admin/traffic/live");
  }

  /**
   * get daily traffic series for charts.
   *
   * @param days - number of days (default 30).
   * @returns A Promise that resolves to the Axios response.
   */
  static getSeries(days: number = 30) {
    return client.get("admin/traffic/series", { params: { days } });
  }
}

export { TrafficService };
